import ChatWindow from "../components/Messages/ChatWindow";
import VendorContacts from "../components/Messages/VendorContacts";

export default function Messages() {
  return (
    <section className="card h-[80vh] flex overflow-hidden">
      <VendorContacts />
      <ChatWindow />
    </section>
  );
}
